import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const storageLimitsEditorBannerEntrypoint = createEntryPoint({
	root: JSResourceForInteraction(
		() => import(/* webpackChunkName: "storage-limits-editor-banner" */ './main'),
	),
	getPreloadProps: () => ({}),
});
